import React from 'react';
import Maps from './Maps'
import ErrorBoundary from '../error/ErrorBoundary';

export default function Dashboard() {
  return (
    <ErrorBoundary>
      <Maps />
    </ErrorBoundary>
  );
}
